<template>
  <div>
    <div
      class="flex md:flex-row flex-col py-14 w-full items-center md:gap-1 gap-4 md:items-end justify-between overflow-hidden"
    >
      <img
        src="../assets/imgs/blackout-logo.svg"
        class="invert md:w-auto w-3/5"
        alt="Blackout Logo"
      />
      <div class="flex flex-col gap-4 items-start md:items-end">
        <a class="font-primary" href="https://www.instagram.com/blackoutmagazin/">
          <div
            class="w-fit px-5 md:px-8 md:hover:invert bg-white duration-300 py-2 md:py-3 border border-black rounded-full flex items-center gap-8 font-primary text-2xl md:text-4xl uppercase font-medium md:text-left text-center"
          >
            follow us
            <img src="../assets/imgs/insta-icon.svg" alt="Instagram Icon" />
          </div>
        </a>
        <div class="flex gap-7 flex-col md:flex-row w-full md:w-auto">
          <a
            class="font-primary text-center md:text-right"
            href="#"
            @click="openOverlay('impressum')"
            >Impressum</a
          >
          <a
            class="font-primary text-center md:text-right"
            href="#"
            @click="openOverlay('datenschutz')"
            >Datenschutz</a
          >
          <div class="font-primary text-center md:text-right">
            Alaska Alice Arad / Bachelor 20 — 24
          </div>
        </div>
      </div>
    </div>
    <!-- Impressum Overlay -->
    <div
      v-if="showOverlay && overlayContent === 'impressum'"
      class="overlay"
    >
      <button class="close-button" @click="closeOverlay">
        <img src="../assets/imgs/close-icon.svg" alt="" />
      </button>
      <div class="overlay-content overflow-y-scroll md:overflow-y-auto">
        <h2 class="text-3xl md:text-5xl uppercase mb-5 font-medium font-primary">
          Impressum
        </h2>
        <p class="font-primary">
          Alaska Alice Arad <br />
          Am Silbermannpark 13 <br />
          86161 Augsburg <br />
          <br />
          Das komplette Projekt entstand im Rahmen meiner Bachelorarbeit. <br />
          Die Webseite weist zwar auf den Kauf des Magazins hin, es kann aber
          darüber nicht wirklich erworben werden. <br />
          <br />
          Kontakt <br />
          Telefon: +49 (0) 176 72437 817 <br />
          E-Mail: blackoutmagazin@gmail.com <br />
          <br />
          Konzeption und Gestaltung <br />
          Alaska Alice Arad <br />
          <br />
          Umsetzung Webseite <br />
          Talin Bennett <br />
          <br />
          Quelle: <br />
          e-recht24.de
        </p>
      </div>
    </div>
    <!-- Datenschutz Overlay -->
    <div
      v-if="showOverlay && overlayContent === 'datenschutz'"
      class="overlay"
    >
      <button class="close-button" @click="closeOverlay">
        <img src="../assets/imgs/close-icon.svg" alt="" />
      </button>
      <div class="overlay-content overflow-y-scroll">
        <h2 class="text-3xl md:text-5xl uppercase mb-5 font-medium font-primary">
          Datenschutz
        </h2>
        <p class="font-primary">
          Präambel <br />
          Mit der folgenden Datenschutzerklärung möchten wir Sie darüber
          aufklären, welche Arten Ihrer personenbezogenen Daten (nachfolgend auch
          kurz als "Daten" bezeichnet) wir zu welchen Zwecken und in welchem
          Umfang im Rahmen der Bereitstellung unserer Applikation verarbeiten.
          <br />
          Die verwendeten Begriffe sind nicht geschlechtsspezifisch. <br />
          Stand: 15. Juli 2024 <br />
          Inhaltsübersicht <br />
          Präambel <br />
          Verantwortlicher <br />
          Übersicht der Verarbeitungen <br />
          Maßgebliche Rechtsgrundlagen <br />
          Sicherheitsmaßnahmen <br />
          Rechte der betroffenen Personen <br />
          Bereitstellung des Onlineangebots und Webhosting <br />
          Präsenzen in sozialen Netzwerken (Social Media) <br />
          <br />
          Verantwortliche <br />
          Alaska Alice AradAm Silbermannpark 1386161 Augsburg <br />
          E-Mail-Adresse: blackoutmagazin@gmail.com <br />
          Übersicht der Verarbeitungen <br />
          Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und
          die Zwecke ihrer Verarbeitung zusammen und verweist auf die betroffenen
          Personen. <br />
          Arten der verarbeiteten Daten <br />
          Kontaktdaten. <br />
          Inhaltsdaten. <br />
          Nutzungsdaten. <br />
          Meta-, Kommunikations- und Verfahrensdaten. <br />
          Protokolldaten. <br />
          <br />
          Kategorien betroffener Personen <br />
          Nutzer. <br />
          <br />
          Zwecke der Verarbeitung <br />
          Kommunikation. <br />
          Feedback. <br />
          Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit. <br />
          Informationstechnische Infrastruktur. <br />
          Öffentlichkeitsarbeit. <br />
          <br />
          Maßgebliche Rechtsgrundlagen <br />
          Maßgebliche Rechtsgrundlagen nach der DSGVO: Im Folgenden erhalten Sie
          eine Übersicht der Rechtsgrundlagen der DSGVO, auf deren Basis wir
          personenbezogene Daten verarbeiten. Bitte nehmen Sie zur Kenntnis, dass
          neben den Regelungen der DSGVO nationale Datenschutzvorgaben in Ihrem
          bzw. unserem Wohn- oder Sitzland gelten können. Sollten ferner im
          Einzelfall speziellere Rechtsgrundlagen maßgeblich sein, teilen wir
          Ihnen diese in der Datenschutzerklärung mit. <br />
          Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO) - die
          Verarbeitung ist zur Wahrung der berechtigten Interessen des
          Verantwortlichen oder eines Dritten notwendig, vorausgesetzt, dass die
          Interessen, Grundrechte und Grundfreiheiten der betroffenen Person, die
          den Schutz personenbezogener Daten verlangen, nicht überwiegen. <br />
          <br />
          Nationale Datenschutzregelungen in Deutschland: Zusätzlich zu den
          Datenschutzregelungen der DSGVO gelten nationale Regelungen zum
          Datenschutz in Deutschland. Hierzu gehört insbesondere das Gesetz zum
          Schutz vor Missbrauch personenbezogener Daten bei der Datenverarbeitung
          (Bundesdatenschutzgesetz - BDSG). Das BDSG enthält insbesondere
          Spezialregelungen zum Recht auf Auskunft, zum Recht auf Löschung, zum
          Widerspruchsrecht, zur Verarbeitung besonderer Kategorien
          personenbezogener Daten, zur Verarbeitung für andere Zwecke und zur
          Übermittlung sowie automatisierten Entscheidungsfindung im Einzelfall
          einschließlich Profiling. Ferner können Landesdatenschutzgesetze der
          einzelnen Bundesländer zur Anwendung gelangen. <br />
          <br />
          Hinweis auf Geltung DSGVO und Schweizer DSG: Diese Datenschutzhinweise
          dienen sowohl der Informationserteilung nach dem Schweizer DSG als auch
          nach der Datenschutzgrundverordnung (DSGVO). Aus diesem Grund bitten wir
          Sie zu beachten, dass aufgrund der breiteren räumlichen Anwendung und
          Verständlichkeit die Begriffe der DSGVO verwendet werden. Insbesondere
          statt der im Schweizer DSG verwendeten Begriffe „Bearbeitung" von
          „Personendaten", "überwiegendes Interesse" und "besonders schützenswerte
          Personendaten" werden die in der DSGVO verwendeten Begriffe
          „Verarbeitung" von „personenbezogenen Daten" sowie "berechtigtes
          Interesse" und "besondere Kategorien von Daten" verwendet. Die
          gesetzliche Bedeutung der Begriffe wird jedoch im Rahmen der Geltung des
          Schweizer DSG weiterhin nach dem Schweizer DSG bestimmt. <br />
          Sicherheitsmaßnahmen <br />
          <br />
          Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter
          Berücksichtigung des Stands der Technik, der Implementierungskosten und
          der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie
          der unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der
          Bedrohung der Rechte und Freiheiten natürlicher Personen geeignete
          technische und organisatorische Maßnahmen, um ein dem Risiko
          angemessenes Schutzniveau zu gewährleisten. <br />
          Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit,
          Integrität und Verfügbarkeit von Daten durch Kontrolle des physischen
          und elektronischen Zugangs zu den Daten als auch des sie betreffenden
          Zugriffs, der Eingabe, der Weitergabe, der Sicherung der Verfügbarkeit
          und ihrer Trennung. Des Weiteren haben wir Verfahren eingerichtet, die
          eine Wahrnehmung von Betroffenenrechten, die Löschung von Daten und
          Reaktionen auf die Gefährdung der Daten gewährleisten. Ferner
          berücksichtigen wir den Schutz personenbezogener Daten bereits bei der
          Entwicklung bzw. Auswahl von Hardware, Software sowie Verfahren
          entsprechend dem Prinzip des Datenschutzes, durch Technikgestaltung und
          durch datenschutzfreundliche Voreinstellungen. <br />
          Sicherung von Online-Verbindungen durch
          TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um die Daten der Nutzer,
          die über unsere Online-Dienste übertragen werden, vor unerlaubten
          Zugriffen zu schützen, setzen wir auf die
          TLS-/SSL-Verschlüsselungstechnologie. Secure Sockets Layer (SSL) und
          Transport Layer Security (TLS) sind die Eckpfeiler der sicheren
          Datenübertragung im Internet. Diese Technologien verschlüsseln die
          Informationen, die zwischen der Website oder App und dem Browser des
          Nutzers (oder zwischen zwei Servern) übertragen werden, wodurch die
          Daten vor unbefugtem Zugriff geschützt sind. TLS, als die
          weiterentwickelte und sicherere Version von SSL, gewährleistet, dass
          alle Datenübertragungen den höchsten Sicherheitsstandards entsprechen.
          Wenn eine Website durch ein SSL-/TLS-Zertifikat gesichert ist, wird dies
          durch die Anzeige von HTTPS in der URL signalisiert. Dies dient als ein
          Indikator für die Nutzer, dass ihre Daten sicher und verschlüsselt
          übertragen werden. <br />
          <br />
          Rechte der betroffenen Personen <br />
          Rechte der betroffenen Personen aus der DSGVO: Ihnen stehen als
          Betroffene nach der DSGVO verschiedene Rechte zu, die sich insbesondere
          aus Art. 15 bis 21 DSGVO ergeben: <br />
          Widerspruchsrecht: Sie haben das Recht, aus Gründen, die sich aus Ihrer
          besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie
          betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1
          lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für
          ein auf diese Bestimmungen gestütztes Profiling. Werden die Sie
          betreffenden personenbezogenen Daten verarbeitet, um Direktwerbung zu
          betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die
          Verarbeitung der Sie betreffenden personenbezogenen Daten zum Zwecke
          derartiger Werbung einzulegen; dies gilt auch für das Profiling, soweit
          es mit solcher Direktwerbung in Verbindung steht. <b></b> Widerrufsrecht
          bei Einwilligungen: Sie haben das Recht, erteilte Einwilligungen
          jederzeit zu widerrufen. Auskunftsrecht: Sie haben das Recht, eine
          Bestätigung darüber zu verlangen, ob betreffende Daten verarbeitet
          werden und auf Auskunft über diese Daten sowie auf weitere Informationen
          und Kopie der Daten entsprechend den gesetzlichen Vorgaben. Recht auf
          Berichtigung: Sie haben entsprechend den gesetzlichen Vorgaben das
          Recht, die Vervollständigung der Sie betreffenden Daten oder die
          Berichtigung der Sie betreffenden unrichtigen Daten zu verlangen. <br />
          Recht auf Löschung und Einschränkung der Verarbeitung: Sie haben nach
          Maßgabe der gesetzlichen Vorgaben das Recht, zu verlangen, dass Sie
          betreffende Daten unverzüglich gelöscht werden, bzw. alternativ nach
          Maßgabe der gesetzlichen Vorgaben eine Einschränkung der Verarbeitung
          der Daten zu verlangen. <br />
          Recht auf Datenübertragbarkeit: Sie haben das Recht, Sie betreffende
          Daten, die Sie uns bereitgestellt haben, nach Maßgabe der gesetzlichen
          Vorgaben in einem strukturierten, gängigen und maschinenlesbaren Format
          zu erhalten oder deren Übermittlung an einen anderen Verantwortlichen zu
          fordern. <br />
          Beschwerde bei Aufsichtsbehörde: Sie haben unbeschadet eines
          anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs
          das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem
          Mitgliedstaat ihres gewöhnlichen Aufenthaltsorts, ihres Arbeitsplatzes
          oder des Orts des mutmaßlichen Verstoßes, wenn Sie der Ansicht sind,
          dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen
          die Vorgaben der DSGVO verstößt. <br />
          <br />
          Bereitstellung des Onlineangebots und Webhosting <br />
          Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur
          Verfügung stellen zu können. Zu diesem Zweck verarbeiten wir die
          IP-Adresse des Nutzers, die notwendig ist, um die Inhalte und Funktionen
          unserer Online-Dienste an den Browser oder das Endgerät der Nutzer zu
          übermitteln. <br />
          Verarbeitete Datenarten: Nutzungsdaten (z. B. Seitenaufrufe und
          Verweildauer, Klickpfade, Nutzungsintensität und -frequenz, verwendete
          Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und
          Funktionen); Meta-, Kommunikations- und Verfahrensdaten (z. B.
          IP-Adressen, Zeitangaben, Identifikationsnummern, beteiligte Personen).
          Protokolldaten (z.B. Logfiles betreffend Logins oder den Abruf von Daten
          oder Zugriffszeiten.). <br />
          Betroffene Personen: Nutzer (z.B. Webseitenbesucher, Nutzer von
          Onlinediensten). <br />
          Zwecke der Verarbeitung: Bereitstellung unseres Onlineangebotes und
          Nutzerfreundlichkeit. Informationstechnische Infrastruktur (Betrieb und
          Bereitstellung von Informationssystemen und technischen Geräten
          (Computer, Server etc.).). <br />
          Aufbewahrung und Löschung: Löschung entsprechend Angaben im Abschnitt
          "Allgemeine Informationen zur Datenspeicherung und Löschung". <br />
          Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
          DSGVO). <br />
          <br />
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
          <br />
          Bereitstellung Onlineangebot auf gemietetem Speicherplatz: Für die
          Bereitstellung unseres Onlineangebotes nutzen wir Speicherplatz,
          Rechenkapazität und Software, die wir von einem entsprechenden
          Serveranbieter (auch "Webhoster" genannt) mieten oder anderweitig
          beziehen; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1
          lit. f) DSGVO). <br />
          <br />
          Präsenzen in sozialen Netzwerken (Social Media) <br />
          Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und
          verarbeiten in diesem Rahmen Nutzerdaten, um mit den dort aktiven
          Nutzern zu kommunizieren oder Informationen über uns anzubieten. <br />
          Wir weisen darauf hin, dass dabei Nutzerdaten außerhalb des Raumes der
          Europäischen Union verarbeitet werden können. Hierdurch können sich für
          die Nutzer Risiken ergeben, weil so zum Beispiel die Durchsetzung der
          Nutzerrechte erschwert werden könnte. Ferner werden die Daten der Nutzer
          innerhalb sozialer Netzwerke im Regelfall für Marktforschungs- und
          Werbezwecke verarbeitet. So können beispielsweise anhand des
          Nutzungsverhaltens und sich daraus ergebender Interessen der Nutzer
          Nutzungsprofile erstellt werden. Letztere finden möglicherweise wiederum
          Verwendung, um etwa Werbeanzeigen innerhalb und außerhalb der Netzwerke
          zu schalten, die mutmaßlich den Interessen der Nutzer entsprechen. Daher
          werden im Regelfall Cookies auf den Rechnern der Nutzer gespeichert, in
          denen das Nutzungsverhalten und die Interessen der Nutzer gespeichert
          werden. Zudem können in den Nutzungsprofilen auch Daten unabhängig der
          von den Nutzern verwendeten Geräten gespeichert werden (insbesondere,
          wenn sie Mitglieder der jeweiligen Plattformen und dort eingeloggt
          sind). <br />
          <br />
          Für eine detaillierte Darstellung der jeweiligen Verarbeitungsformen und
          der Widerspruchsmöglichkeiten (Opt-out) verweisen wir auf die
          Datenschutzerklärungen und Angaben der Betreiber der jeweiligen
          Netzwerke. <br />
          Auch im Fall von Auskunftsanfragen und der Geltendmachung von
          Betroffenenrechten weisen wir darauf hin, dass diese am effektivsten bei
          den Anbietern geltend gemacht werden können. Nur Letztere haben jeweils
          Zugriff auf die Nutzerdaten und können direkt entsprechende Maßnahmen
          ergreifen und Auskünfte geben. Sollten Sie dennoch Hilfe benötigen, dann
          können Sie sich an uns wenden. Verarbeitete Datenarten: Kontaktdaten
          (z.B. Post- und E-Mail-Adressen oder Telefonnummern); Inhaltsdaten (z.
          B. textliche oder bildliche Nachrichten und Beiträge sowie die sie
          betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder
          Zeitpunkt der Erstellung). Nutzungsdaten (z. B. Seitenaufrufe und
          Verweildauer, Klickpfade, Nutzungsintensität und -frequenz, verwendete
          Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und
          Funktionen). <br />
          Betroffene Personen: Nutzer (z.B. Webseitenbesucher, Nutzer von
          Onlinediensten). <br />
          Zwecke der Verarbeitung: Kommunikation; Feedback (z.B. Sammeln von
          Feedback via Online-Formular). Öffentlichkeitsarbeit. Aufbewahrung und
          Löschung: Löschung entsprechend Angaben im Abschnitt "Allgemeine
          Informationen zur Datenspeicherung und Löschung". Rechtsgrundlagen:
          Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO). <br />
          <br />
          Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:
          <br />
          Instagram: Soziales Netzwerk, ermöglicht das Teilen von Fotos und
          Videos, das Kommentieren und Favorisieren von Beiträgen,
          Nachrichtenversand, Abonnieren von Profilen und Seiten; Dienstanbieter:
          Meta Platforms Ireland Limited, Merrion Road, Dublin 4, D04 X2K5,
          Irland; Rechtsgrundlagen: Berechtigte Interessen (Art. 6 Abs. 1 S. 1
          lit. f) DSGVO); Website: https://www.instagram.com;
          Datenschutzerklärung: https://privacycenter.instagram.com/policy/.
          Grundlage Drittlandtransfers: Data Privacy Framework (DPF). <br />
          Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas
          Schwenke
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";

const showOverlay = ref(false);
const overlayContent = ref("");

const openOverlay = (content) => {
  overlayContent.value = content;
  showOverlay.value = true;
  document.body.style.overflow = "hidden";
};

const closeOverlay = () => {
  showOverlay.value = false;
  document.body.style.overflow = "auto";
};

// Optional: Handle escape key to close overlay
const handleEscapeKey = (event) => {
  if (event.key === "Escape") {
    closeOverlay();
  }
};

onMounted(() => {
  window.addEventListener("keydown", handleEscapeKey);
});

onUnmounted(() => {
  window.removeEventListener("keydown", handleEscapeKey);
});
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  opacity: 1;
  transition: opacity 0.3s;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
  color: black;
  padding: 10px;
  border: none;
  cursor: pointer;
}

.overlay-content {
  padding: 20px;
  color: white;
  max-height: 100vh;
  padding-right: 80px;
}
</style>
